var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineCheckmarkCircle2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline_checkmark-circle-2",
    "data-name": "outline/checkmark-circle-2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Icon-\\u0421olor",
    "data-name": "\\uD83C\\uDFA8-Icon-\\u0421olor",
    d: "M11.971,2a10.977,10.977,0,0,1,2.381.278,1,1,0,0,1-.469,1.945A8.817,8.817,0,0,0,11.977,4,8,8,0,0,0,12,20h.023A8,8,0,0,0,20,11.977a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1A10,10,0,0,1,12.029,22H12A10,10,0,0,1,4.909,4.949,9.935,9.935,0,0,1,11.971,2Zm6.277,4.341a1,1,0,0,1,1.5,1.318h0l-7,8a1,1,0,0,1-.719.341H12a1,1,0,0,1-.707-.293h0l-3-3a1,1,0,0,1,1.414-1.414h0l2.244,2.244Z",
    fill: "#298807"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCheckmarkCircle2);
export default __webpack_public_path__ + "static/media/outline-checkmark-circle-2.5a8245f5db52682307975a21bacced95.svg";
export { ForwardRef as ReactComponent };